/**
 * Chapter 10 — what is not built yet: the dashed rungs fade in from the
 * pinned roadmap, then the fine print. The chapter shrinks as phases ship;
 * with no rung left it says the roadmap is done.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { Illustration } from '../../motion/Illustration';
import { Enter } from '../../motion/Node';
import { FINE_PRINT, ROADMAP } from '../../roadmap/roadmap';

const CYCLE = 12;

export const RoadmapIllustration: FC = () => (
  <Illustration cycleSeconds={CYCLE}>
    {ROADMAP.length === 0 ? (
      <Enter at={0}>
        <p className="rounded-md border border-success/40 bg-success/10 px-2.5 py-1.5 text-xs font-medium text-success">
          Every rung of the roadmap is built — Auto-send was the last.
        </p>
      </Enter>
    ) : null}
    <ol className="flex flex-col gap-1.5 text-xs">
      {ROADMAP.map((r, i) => (
        <li key={r.phase}>
          <Enter at={i}>
            <div className="flex flex-wrap items-baseline gap-2 rounded-md border border-dashed border-border px-2.5 py-1.5">
              <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">phase {r.phase}</span>
              <span className="font-medium">{r.title}</span>
              <span className="text-muted-foreground">— {r.what}</span>
              {r.gate ? <span className="rounded bg-warning/15 px-1.5 py-px text-[10px] font-semibold text-warning">{r.gate}</span> : null}
            </div>
          </Enter>
        </li>
      ))}
    </ol>
    <Enter at={ROADMAP.length + 1}>
      <p className="mt-3 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">fine print — inside what is built</p>
      <ul className="mt-1 flex flex-col gap-0.5 text-xs text-muted-foreground">
        {FINE_PRINT.map((line) => <li key={line}>· {line}</li>)}
      </ul>
    </Enter>
  </Illustration>
);
